import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ruCommon from './locales/ru/common.json';
import ruAuth from './locales/ru/auth.json';
import ruReports from './locales/ru/reports.json';
import ruCreate from './locales/ru/create.json';
import ruProfile from './locales/ru/profile.json';
import ruLanding from './locales/ru/landing.json';
import ruLegal from './locales/ru/legal.json';
import ruEditor from './locales/ru/editor.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enReports from './locales/en/reports.json';
import enCreate from './locales/en/create.json';
import enProfile from './locales/en/profile.json';
import enLanding from './locales/en/landing.json';
import enLegal from './locales/en/legal.json';
import enEditor from './locales/en/editor.json';

const lang = process.env.REACT_APP_LANGUAGE || 'ru';

i18n.use(initReactI18next).init({
  lng: lang,
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  resources: {
    ru: {
      common: ruCommon,
      auth: ruAuth,
      reports: ruReports,
      create: ruCreate,
      profile: ruProfile,
      landing: ruLanding,
      legal: ruLegal,
      editor: ruEditor,
    },
    en: {
      common: enCommon,
      auth: enAuth,
      reports: enReports,
      create: enCreate,
      profile: enProfile,
      landing: enLanding,
      legal: enLegal,
      editor: enEditor,
    },
  },
});

export default i18n;
